import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo, useState } from 'react';
import { ModalWindow, useLocalizeMessage } from 'libs.nucleus';
import { RadioGroupSection } from 'libs.react';
import { AuthContext } from '../../features';
export const SwitchWorkspaceModal = ({ entities, email, onClose, onSubmit }) => {
    const translate = useLocalizeMessage();
    const { lastEntities } = useContext(AuthContext);
    const options = useMemo(() => {
        return entities.map((entity) => ({
            dataTestId: `workspace-${entity.id}`,
            label: entity.displayName,
            value: entity.id.toString(),
        }));
    }, [entities]);
    const [selectedEntity, setSelectedEntity] = useState(() => {
        const lastEntity = lastEntities.find((entityInfo) => entityInfo.email === email);
        if (!lastEntity) {
            return options[0].value;
        }
        return options.find((option) => option.value === lastEntity.entityId.toString())?.value || options[0].value;
    });
    const handleSelectionChange = (value) => {
        setSelectedEntity(value);
    };
    const handleSubmit = () => {
        const entity = entities.find((e) => e.id.toString() === selectedEntity);
        entity && onSubmit(entity);
    };
    return (_jsx(ModalWindow, { isOpen: true, dataTestId: 'switch-workspace-modal', title: translate('Choose workspace'), subtitle: translate('You have access to the following sponsors'), closeWindow: () => null, footerPrimaryActionButton: {
            label: translate('Continue'),
            onClick: handleSubmit,
            dataTestId: 'switch-workspace-modal-continue-button',
        }, footerSecondaryActionButtons: [
            {
                label: translate('Cancel'),
                onClick: onClose,
                dataTestId: 'switch-workspace-modal-cancel-button',
            },
        ], width: 'full', children: _jsx("div", { className: 'flex items-center justify-center size-full', children: _jsx("div", { className: 'w-input-lg max-h-full', children: _jsx(RadioGroupSection, { dataTestId: 'workspace-radio-group', options: options, selectedValue: selectedEntity, onSelectionChange: handleSelectionChange }) }) }) }));
};
